


interface TokenIconProps {
    size?: number;
    className?: string;
}

export const TokenIcon = ({ size = 24, className = '' }: TokenIconProps) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <circle cx="16" cy="16" r="15" fill="url(#token_gradient_bg)" stroke="url(#token_gradient_border)" strokeWidth="2" />
            <circle cx="16" cy="16" r="10" stroke="url(#token_gradient_inner)" strokeWidth="1" strokeDasharray="2 2" />
            <path
                d="M16 6L18.5 13.5L24 16L18.5 18.5L16 26L13.5 18.5L8 16L13.5 13.5L16 6Z"
                fill="url(#token_gradient_symbol)"
            />
            <defs>
                <linearGradient id="token_gradient_bg" x1="16" y1="1" x2="16" y2="31" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FFFBEB" stopOpacity="0.2" />
                    <stop offset="1" stopColor="#FEF3C7" stopOpacity="0.1" />
                </linearGradient>
                <linearGradient id="token_gradient_border" x1="16" y1="0" x2="16" y2="32" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCD34D" />
                    <stop offset="1" stopColor="#D97706" />
                </linearGradient>
                <linearGradient id="token_gradient_inner" x1="16" y1="6" x2="16" y2="26" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#F59E0B" />
                    <stop offset="1" stopColor="#B45309" />
                </linearGradient>
                <linearGradient id="token_gradient_symbol" x1="16" y1="6" x2="16" y2="26" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#FCD34D" />
                    <stop offset="1" stopColor="#B45309" />
                </linearGradient>
            </defs>
        </svg>
    );
};
